import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";
import { ExpressionBuilder } from "../ExpressionBuilder";
import { expressionStoryData } from "../Testing/ExpressionData";
import { DateGetYearExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateGetYearExpression";
import { DateEqualToExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateEqualToExpression";
import { DateGreaterThanExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateGreaterThanExpression";
import { DateGetHourExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateGetHourExpression";
import { DateGetMonthExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateGetMonthExpression";
import { DateLessThanExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateLessThanExpression";
import { DateGetTodayExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateGetTodayExpression";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";
import { DateGetDayExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateGetDayExpression";
import { DateGetMinuteExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateGetMinuteExpression";
import { DateNowExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateNowExpression";
import { DateAddXExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateAddXExpression";
import { DateSubtractXExpression } from "../../rule-engine-core/Expressions/Expressions/Date/DateSubtractXExpression";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

export const DateExpressionStories = [
    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateEqualToExpression();
            expression.value1.value = "2020-02-02";
            expression.value2.value = "2020-02-02";

            exp.inputData = expressionStoryData;

            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Date Equals",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateGetDayExpression();
            expression.value1.value = "2020-02-02";

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Get Day",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateGetHourExpression();
            expression.value1.value = "2020-02-02";

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Get Hour",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateGetHourExpression();
            expression.value1.value = "2020-02-02";

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Get Hour",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateGetMinuteExpression();
            expression.value1.value = "2020-02-02";
            exp = new ExpressionConfiguration();

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Get Hour",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateGetMonthExpression();
            expression.value1.value = "2020-02-02";

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Get Month",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateGetTodayExpression();

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Get Today",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateGetYearExpression();
            expression.value1.value = "2020-02-02";

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Get Year",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateGreaterThanExpression();
            expression.value1.value = "2020-02-05";
            expression.value2.value = "2020-02-02";

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Greater Than",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateLessThanExpression();
            expression.value1.value = "2020-02-03";
            expression.value2.value = "2020-02-05";

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Less Than",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateNowExpression();

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Now",
    ),

    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateAddXExpression();
            expression.baseDate.subExpression = new DateNowExpression();
            expression.adjustBy.value = 30;

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Add X",
    ),
    new StoryNode(
        () => {
            let expression: AppGlueAny;
            let exp = new ExpressionConfiguration();

            expression = new DateSubtractXExpression();
            expression.baseDate.subExpression = new DateNowExpression();
            expression.adjustBy.value = 30;

            exp.inputData = expressionStoryData;
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Date",
        "Subtract X",
    ),
];
